
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns1b8e85966951ef590ef34be6575c5714en from './en.yaml'
            i18n.addResourceBundle('en', '1b8e85966951ef590ef34be6575c5714', flattenObject(ns1b8e85966951ef590ef34be6575c5714en), true, true);
        
        export default '1b8e85966951ef590ef34be6575c5714';
    